import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/team")({
  component: lazyRouteComponent(() => import("./-pages/admin.team")),
  head: () => ({
    meta: [{ title: "Team · Lecmo Admin" }, { name: "robots", content: "noindex" }],
  }),
});
